import { jsxs as a, jsx as i } from "react/jsx-runtime";
import { useMultiStyleConfig as l, Flex as c, Box as s } from "@chakra-ui/react";
import { Typography as g } from "../../dataDisplay/Typography/Typography.mjs";
import { Badge as x } from "../../dataDisplay/Badge/Badge.mjs";
const b = ({ orientation: o = "vertical", type: r = "beta", ...e }) => {
  const t = l("MySgiLogo");
  return /* @__PURE__ */ a(
    c,
    {
      sx: t.container,
      flexDirection: o === "vertical" ? "column" : "row",
      ...o === "horizontal" && { gap: 1 },
      ...e,
      children: [
        /* @__PURE__ */ i(g, { as: "div", sx: t.label, children: "MySGI" }),
        /* @__PURE__ */ i(s, { children: /* @__PURE__ */ i(
          x,
          {
            sx: t.badge,
            ...o === "vertical" && {
              position: "relative",
              float: "right",
              right: "-8px",
              bottom: "-2px"
            },
            ...o === "horizontal" && { marginBottom: "3px" },
            width: r === "beta" ? "44px" : "54px",
            color: r === "beta" ? "white" : "gray.800",
            background: r === "beta" ? "#3AC2CE" : "#FFD600",
            children: r === "beta" ? "Beta" : "Classic"
          }
        ) })
      ]
    }
  );
};
export {
  b as MySgiLogo
};
